// extracted by mini-css-extract-plugin
export default {"container":"AdminHomeOrder_container__R2x+P","left":"AdminHomeOrder_left__1a2gG","right":"AdminHomeOrder_right__qCz9t"};